import { Button } from '@cibli/shared';

import { cn } from '@/lib/utils';
type IconButtonProps = {
  icon: React.ReactNode;
  onClick: () => void;
  className?: string;
};

const IconButton = ({ icon, onClick, className }: IconButtonProps) => {
  return (
    <Button
      size="icon"
      className={cn('h-14 w-14', className)}
      variant="secondary"
      onClick={onClick}
    >
      {icon}
    </Button>
  );
};

export default IconButton;
